import React from 'react';
import './link-tree.css';

function LinkTree() {
    return (
        <div className="link-tree">
            <h2>My Links</h2>
            <ul>
                <li><a href="https://soundcloud.com/joshalmostt">SoundCloud</a></li>
                <li><a href="https://twitter.com/JoshAlmostt">Twitter</a></li>
                <li><a href="https://www.instagram.com/joshalmostt/">Instagram</a></li>
            </ul>
        </div>
    )
}

export default LinkTree;